var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((this.list),function(item,i){return _c('span',{key:i},[(i>0)?[_vm._v(_vm._s(_vm.sep))]:_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(item))]},{"item":item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }